import axios from 'axios';

const log = require("loglevel").getLogger("SalesforceManagerService");
log.setLevel("error");

export const getSalesforceManagers = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/salesforce-managers`)
		.then(async response => {
			const res = response.data.data;
			log.debug("IntegrationService -> getSalesforceManagers -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getSalesforceManagers -> error: ");
			log.debug(response);
			return null;
		});
};

export const saveSalesforceManager = ({ id, packageUrl, sandboxPackageUrl }) => {
  return axios.put(`${process.env.REACT_APP_HOST_URL}/salesforce-managers`, {
    id, packageUrl, sandboxPackageUrl,
  })
    .then(async response => {
      const res = response.data;
      log.debug("SalesforceManagerService -> saveSalesforceManager -> return");
      return res;
    })
    .catch(response => {
      log.debug("SalesforceManagerService -> saveSalesforceManager -> error: ");
      log.debug(response);
      return null;
    });
};